import * as React from 'react';
import { styled } from '@mui/material/styles';
import { TableContainer, TableHead, TableRow, Paper, TableBody, Table, TableCell, tableCellClasses } from '@mui/material';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#99b3d98c",
    color: theme.palette.common.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
export default function CustomizedTables({ landDevelopment }) {

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>S1#</StyledTableCell>
            <StyledTableCell align="right">Plot No</StyledTableCell>
            <StyledTableCell align="right">Plot Area</StyledTableCell>
            <StyledTableCell align="right">Type of Land Development</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {landDevelopment.map((row, index) => (
            <StyledTableRow key={row.id || index}>
              <StyledTableCell component="th" scope="row">
                {index + 1}
              </StyledTableCell>
              <StyledTableCell align="right">{row.plotNo}</StyledTableCell>
              <StyledTableCell align="right">{row.plotarea}</StyledTableCell>
              <StyledTableCell align="right">{row.landType}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
